import { apiAuth, apiResponseType } from ".";

export const getEmployeeVacations = (employeeId: number) =>
  apiAuth.get(`employee-vacations?employee_id=${employeeId}`) as apiResponseType;

export const createEmployeeVacation = (data) =>
  apiAuth.post("/employee-vacations/store", data) as apiResponseType;

export const updateEmployeeVacation = (uuid: string, data) =>
  apiAuth.post(`employee-vacations/${uuid}/update`, data) as apiResponseType;

export const deleteEmployeeVacation = (uuid: string) =>
  apiAuth.delete(`employee-vacations/${uuid}/destroy`) as apiResponseType;
